import React, { SFC } from 'react'

import { debug } from '../index'

import './debug.scss'
type Props = {
  pretty?: boolean
  children: string | number | boolean | object | undefined
}
export const Debug: SFC<Props> = ({ children, pretty }) => <pre className="debug">{debug(children, pretty)}</pre>



// WEBPACK FOOTER //
// ./src/app/shared/utils/debug.tsx